import {SkillsGridComponent} from '../../../js/custom-components/about/skills-grid-component';
class AboutBlockComponent extends React.Component{	
		render(){
		
		return (
			<section 
				id="about__block" className="about__block">
				<h1 className="about__block__heading">About me</h1>
				<div className="about__block__grid">
					<div className="col-xs-6">
						<h3 className="about__block__title__text">-info:</h3>
						<p>Hello, I am Emmanuel a Front-end Developer currently based in Brighton. I enjoy creating interactive and functional user interfaces and I love exploring every possible solution for a problem. But more importantly... I know how to vertically center a <b>&lsaquo;div&rsaquo;</b>!!!</p>
					</div>
					<div className="col-xs-6">
						<h3 className="about__block__title__text">-skills:</h3>
						<SkillsGridComponent />
					</div>
				</div>
				
				
			</section>
		);
	}
}
export { AboutBlockComponent };


// WEBPACK FOOTER //
// in/js/custom-components/about/about-block-component.js